import { ReactNode } from 'react';

import { CloselinkWordmark } from '../../common/icons/closelink/CloselinkWordmark';
import { Box } from '../../common/ui/Box';

import { OnboardingFooter } from './OnboardingFooter';

interface AuthenticationPageContentBoxProps {
    children: ReactNode;
    belowBoxContent?: ReactNode;
}

export const AuthenticationPageContentBox = (props: AuthenticationPageContentBoxProps) => {
    return (
        <Box height="100%" display="grid" gridTemplateRows="1fr auto">
            <Box paddingTop={48} marginX="auto" width="440px" marginBottom={24}>
                <CloselinkWordmark color="blue" width={120} />
                <Box
                    paddingX={48}
                    paddingY={40}
                    variant="shadow"
                    marginTop={32}
                    backgroundColor="white"
                    boxShadow="large"
                    borderRadius={8}
                >
                    {props.children}
                </Box>
                {props.belowBoxContent ? <Box marginTop={32}>{props.belowBoxContent}</Box> : null}
            </Box>
            <OnboardingFooter />
        </Box>
    );
};
